import { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import { Subtitle2 } from 'components/UI/MDC/Typography/Typography';
import { getInitialsFromPerson } from './_utils';

const MSPerson = ({ person = {}, ...props }) => {
	const [sInitials, setInitials] = useState('');

	useEffect(() => {
		if (Object.keys(person).length > 0) {
			setInitials(getInitialsFromPerson(person));
		}
	}, [person]);

	return (
		<Avatar sx={{ bgcolor: '#c784e2', height: 30, width: 30 }} {...props}>
			<Subtitle2>{sInitials}</Subtitle2>
		</Avatar>
	);
};

export { MSPerson };
